import React, {CSSProperties, useEffect, useState} from 'react';
import {Button, Checkbox, ConfigProvider, DatePicker, Input, Table, theme, Tooltip} from "antd";
import {ColumnsType} from "antd/es/table";
import 'dayjs/locale/ko'; // 또는 사용하고자 하는 로케일에 맞게 변경
import locale from 'antd/locale/ko_KR';
import dayjs from "dayjs";
import {formatDate, getCurrentDateTime, getFirstDayOfCurrentMonth} from "../../../../../Common/util/DateUtil";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {TB_STORAGE_FILE, TB_STORAGE_FILE_RETURN} from "./data/TB_STORAGE_FILE";
import {bytesToFileSizeString} from "../../../../../Common/util/FileUtil";
import SelectArchive from "../../common/component/SelectArchive";
import ProgressModal from "../../../common/ProgressModal";
import useDownloadFilewithPercent from "../../../../common/downloadFile/useDownloadFilewithPercent";
import EllipsisDiv from "../../common/component/EllipsisDiv";
import WizTooltip from "../../../../../Common/component/WizTooltip/WizTooltip";
import {handleCopyClick} from "../../../../../Common/util/ClipboardUtil";
import {CopyOutlined} from "@ant-design/icons";

const StorageFileMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const { RangePicker } = DatePicker;

    /*
    const { data} = useCommonUseQuery<TB_MONITORING[]>(
        queryKey,
        () =>procAdminService<TB_MONITORING[]>("post", `${serviceCode}ADS24`, null));
    */
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TB_STORAGE_FILE[]>([]);


    const curTime:string  = getCurrentDateTime();
    const firstDayMonth =getFirstDayOfCurrentMonth();
    const firstDay = firstDayMonth.substring(0, firstDayMonth.indexOf(" "));
    const toDay = curTime.substring(0, curTime.indexOf(" "));
    const [startDate, setStartDate] = useState<string>(`${firstDay} 00:00:00`);
    const [endDate, setEndDate] = useState<string>(`${toDay} 23:59:59`);
    const [fileId,setFileId] = useState<string>('');
    const [fileName, setFileName] = useState<string>('');
    const { downloadFileAdmin, percent} = useDownloadFilewithPercent();
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [selectArchive, setSelectArchive] = useState<string>('');
    const [pagination, setPagination] = useState({
        showSizeChanger: false,
        current:1,
        pageSize: 15,
        total: 0,
    });
    const onSearch = (pageNo:number) => {
        setLoading(true);

        const requestParam = {
            startDate:startDate,
            endDate:endDate,
            selectArchive:selectArchive,
            fileId:fileId,
            fileName:fileName,
            pageNo:pageNo,
            pageSize:pagination.pageSize,
        }

        procAdminService<TB_STORAGE_FILE_RETURN>("post", `${serviceCode}ADS17`, requestParam).then(
            (response:TB_STORAGE_FILE_RETURN)=>{
                setData(response.tbStorageFiles);
                setPagination({current: pageNo, pageSize: pagination.pageSize, showSizeChanger: pagination.showSizeChanger, total: response.total});
            }
        ).finally(()=>{
            setLoading(false);
        });
    }



    const handleTableChange = (pagination:any) => {
        const { current, pageSize } = pagination;
        onSearch(current);
    };

    const tableStyle:CSSProperties = {
        paddingLeft:'10px'
        , paddingRight:'10px'
        , paddingBottom: '9px'
        , margin:'0'
        , fontSize:'12px'
    }

    const columns: ColumnsType<TB_STORAGE_FILE> = [
        {
            title: '아카이브명',
            dataIndex: 'storageName',
            key: 'storageName',
            width:"110px",
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: '파일ID',
            dataIndex: 'fileId',
            key: 'fileId',
            width:"150px",
            ellipsis:true,
            render: (text: string) =>
                <EllipsisDiv style={tableStyle} >
                    <Tooltip placement="topLeft" arrow={false} title={text}>
                        {text}
                    </Tooltip>
                </EllipsisDiv>
            ,
        },
        {
            title: '파일명',
            dataIndex: 'fileName',
            key: 'fileName',
            width:"300px",
            render: (text: string, record:TB_STORAGE_FILE) =>
                <EllipsisDiv style={tableStyle} >
                    <Tooltip placement="topLeft" arrow={false} title={`${text}.${record.fileExtension} 다운로드`}>
                        <div style={{ ...tableStyle, alignItems: 'left', justifyContent: 'left' }}>
                    <span
                        className="link-style-button"
                        onClick={(e) => {
                            e.preventDefault(); // 기본 링크 동작을 막습니다.
                            setModalVisible(true);
                            downloadFileAdmin(record.fileId, `${text}.${record.fileExtension}`, record.fileSize).finally(() => {
                                setTimeout(() => {
                                        setModalVisible(false);
                                    }
                                    , 500);

                            });
                        }}
                    >
                        <b>{`${text}.${record.fileExtension}`}</b>
                        </span>
                        </div>
                    </Tooltip>
                </EllipsisDiv>
            ,
        },
        {
            title: '파일크기',
            dataIndex: 'fileSize',
            key: 'fileSize',
            width:"80px",
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    {bytesToFileSizeString(parseInt(text))}
                </div>
            ,
        },
        {
            title: '파일경로',
            dataIndex: 'savePath',
            key: 'savePath',
            width:"200px",
            ellipsis:true,
            render: (text: string, record:TB_STORAGE_FILE) =>
                    <EllipsisDiv style={tableStyle} >
                        <WizTooltip placement={"topLeft"} title="파일경로복사">
                            <Button type="link" style={{marginLeft:"5px"}} shape="circle" onClick={()=>{handleCopyClick(`${record.tbStorageDirDetail.storageDir.storagePath}/${record.tbStorageDirDetail.storageDir.dirYear}/${record.tbStorageDirDetail.storageDir.dirMonth}/${record.tbStorageDirDetail.storageDir.dirKey}/${record.tbStorageDirDetail.detailDirKey}/${record.fileId}`).then()}} icon={<CopyOutlined />}/>
                        </WizTooltip>
                        <Tooltip placement="topLeft" arrow={false} title= {`${record.tbStorageDirDetail.storageDir.storagePath}/${record.tbStorageDirDetail.storageDir.dirYear}/${record.tbStorageDirDetail.storageDir.dirMonth}/${record.tbStorageDirDetail.storageDir.dirKey}/${record.tbStorageDirDetail.detailDirKey}/${record.fileId}`}>
                            {`${record.tbStorageDirDetail.storageDir.storagePath}/${record.tbStorageDirDetail.storageDir.dirYear}/${record.tbStorageDirDetail.storageDir.dirMonth}/${record.tbStorageDirDetail.storageDir.dirKey}/${record.tbStorageDirDetail.detailDirKey}/${record.fileId}`}
                        </Tooltip>
                    </EllipsisDiv>
            ,
        },
        {
            title: '압축여부',
            dataIndex: 'isCompressed',
            key: 'isCompressed',
            width:"80px",
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox checked={text === "1" ? true : false}/>
                </div>
            ,
        },
        {
            title: '암호화여부',
            dataIndex: 'isEncryption',
            key: 'isEncryption',
            width:"90px",
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox checked={text === "1" ? true : false}/>
                </div>
            ,
        },
        {
            title: '등록일',
            dataIndex: 'firstRegTime',
            key: 'firstRegTime',
            width:"150px",
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },

    ];


    useEffect(()=>{
        onSearch(1);
    }, []);

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                    <ConfigProvider locale={locale}>
                        <RangePicker    style={{marginLeft : "5px"}}
                                        defaultValue={ [dayjs(startDate, 'YYYY-MM-DD HH:mm:ss'), dayjs(endDate, 'YYYY-MM-DD HH:mm:ss')] }
                                        value={[dayjs(startDate, 'YYYY-MM-DD HH:mm:ss'), dayjs(endDate, 'YYYY-MM-DD HH:mm:ss')]}
                                        format={'YYYY-MM-DD'}
                                        onChange={(e, dateStrings: [string, string])=>{
                                            setStartDate(`${dateStrings[0]} 00:00:00`);
                                            setEndDate(`${dateStrings[1]} 23:59:59`);
                                        }}
                        />
                    </ConfigProvider>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <SelectArchive onChangeValue={(value)=>{setSelectArchive(value)}}/>
                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}} placeholder={"파일ID"}
                        value={ fileId }
                        onChange={(e)=>{
                            setFileId(e.target.value);
                        }}
                />
                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}}
                        value={fileName}
                        onChange={(e)=>{
                            setFileName(e.target.value);
                        }}
                        placeholder={"파일명"}/>

                <Button style={{marginRight:"5px", marginLeft:"5px"}}type="primary" size="small" onClick={()=>{onSearch(1)}}>조회</Button>
            </div>
        </nav>
        <Table columns={columns}
                loading={loading}
                dataSource={data}
                pagination={pagination}
                rowKey="fileId"
                onChange={handleTableChange}
        />
            <ProgressModal title="파일 다운로드" percent={percent} visible={modalVisible}/>
        </>
    );
};

export default StorageFileMgr;
